import React from "react";
import { PageNewState, addCmpProjectDialogInitialState } from ".";

export const AddCmpProjectDialogContext = React.createContext({
  pageState: addCmpProjectDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
